import { use, Suspense, useState, useEffect } from "react";
import styles from "./StockMessage.module.scss";
import { useVariant } from "@~/contexts/VariantContext/VariantContext";

function StockMessageContent() {
  const { onlineStock } = useVariant();
  const stockData = use(onlineStock);
  const stockMessage = stockData?.stockMessage;

  if (!stockMessage) {
    return null;
  }

  return (
    <p data-component="StockMessage" className={styles.message}>
      {stockMessage}
    </p>
  );
}

function StockMessageLoading() {
  return (
    <p data-component="StockMessage" className={styles["message-loading"]} />
  );
}

export function StockMessage() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <StockMessageLoading />;
  }

  return (
    <Suspense fallback={<StockMessageLoading />}>
      <StockMessageContent />
    </Suspense>
  );
}
